export default defineI18nConfig(() => {
  const { DEFAULT_LOCALE } = useRuntimeConfig().public;

  return {
    fallbackLocale: DEFAULT_LOCALE,
  };
});
